import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { BOOKING_BASE_ROUTES } from './booking-base.routes';

export const BOOKINGS_BOOKING_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);

  return () => {
    const routes: ABP.Route[] = [...BOOKING_BASE_ROUTES];
    routesService.add(routes);
  };
}
